"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var Text_1 = __importDefault(require("../../Text/Text"));
var layout_1 = require("../../layout");
var variables_1 = require("../../../style/variables");
var react_2 = require("react");
var shared_1 = require("../../../shared");
var apps_1 = require("../../../icons/apps");
// eslint-disable-next-line max-len
var borderImageSource = 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50.52%, rgba(255, 255, 255, 0) 100%) 1';
var styles = {
    container: react_1.css({
        padding: 6,
        height: 52,
        borderBottom: '1px solid',
        borderImage: borderImageSource,
    }),
    logoWrapper: react_1.css({
        minWidth: 40,
        display: 'grid',
        placeItems: 'center',
        width: 40,
        height: 40,
        fontSize: 24,
    }),
};
var SidebarHeader = function (_a) {
    var icon = _a.icon, title = _a.title;
    var _b = react_2.useContext(shared_1.AppContext), currentApp = _b.currentApp, apps = _b.apps;
    var finalTitle = react_2.useMemo(function () { var _a; return title !== null && title !== void 0 ? title : (_a = apps.find(function (app) { return app.type === currentApp; })) === null || _a === void 0 ? void 0 : _a.name; }, [title, apps, currentApp]);
    var Icon = icon !== null && icon !== void 0 ? icon : apps_1.APP_TO_ICON_MAP[currentApp];
    return (react_1.jsx(layout_1.Flex, { gap: 6, alignItems: "center", css: styles.container },
        Icon && react_1.jsx("div", { css: styles.logoWrapper },
            react_1.jsx(Icon, { size: 40 })),
        react_1.jsx(Text_1.default.SectionHeading, { css: { whiteSpace: 'nowrap' }, color: "var(" + variables_1.RootColor.White + ")", size: 18 }, finalTitle)));
};
SidebarHeader.displayName = 'Sidebar.Header';
exports.default = SidebarHeader;
